
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1345","height":"1345","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M929.302 414.993c246.508 246.482 384.588 560.216 414.748 882.177 3.73 39.81-43.84 62.83-72.14 34.53L12.452 72.42C-15.364 44.57 6.757-3.441 45.927.196 368.309 30.13 682.481 168.237 929.302 414.993z","fill":"#1CEBCF"}})])
          )
        }
      }
    